import blindbox from './blindbox'
import jyorder from './jyorder'
import invoice from './invoice'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    blindbox,
    jyorder,
    invoice,
  }
}
